<div class="container">
  <div class="header">
    <p>
      Scan package for order #{{ order.orderNumber }} @if (order.splitted) {
      <span>{{this.orderNumberText}}</span>
      }
    </p>
    <pdq-button (onClick)="onCancel()" variant="ghost" iconColor="var(--on-surface-light)" icon="close"></pdq-button>
  </div>
  <div class="content">
    @if (banner) {
    <pdq-banner class="banner" [variant]="banner.variant" [bannerTitle]="banner.title">
      <ul class="banner__bullets">
        @for (bullet of banner.bullets; track bullet) {
        <li>{{bullet}}</li>
        }
      </ul>
    </pdq-banner>
    }
    <div class="scan">
      <p>Scan package to mark as fulfilled</p>
      <p>
        <span class="scan__input">
          <pdq-input
            placeholder="Scan Barcode/SKU"
            [value]="scannedToken"
            [disabled]="isLoading"
            [autofocus]="true"
            (onEnter)="scanBox()"
            [(ngModel)]="scannedToken"
            #scan></pdq-input>
        </span>
        <pdq-button
          class="scan__btn"
          icon="scan"
          variant="dark"
          label="Update"
          (onClick)="scanBox()"
          [loading]="isLoading"></pdq-button>
      </p>
    </div>
  </div>
  <div class="footer">
    @for (tag of displayTags; track tag) {
    <pdq-tag [value]="tag" maxWidth="150"></pdq-tag>
    }
  </div>
</div>
